(function () {
  var STORAGE_KEY = 'nk_wishlist_handles';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('nk:wishlist-updated', { detail: { list: list } }));
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    setWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function paintButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-nk-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      btn.classList.toggle('is-active', list.indexOf(handle) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nk-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var isActive = toggle(handle);
    btn.classList.toggle('is-active', isActive);
  });

  document.addEventListener('nk:wishlist-updated', paintButtons);
  document.addEventListener('DOMContentLoaded', paintButtons);
  if (document.readyState !== 'loading') paintButtons();

  window.nkWishlist = { get: getWishlist, toggle: toggle };
})();
